"use client";

import posthog from "posthog-js";
import { PostHog } from "posthog-js";

export const initPostHog = () => {
  try {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://app.posthog.com",
      capture_pageview: false,
      debug: false,
    });
  } catch (error) {
    // In development, log the error
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to initialize PostHog:", error);
    }
  }
};

export const identifyUser = (
  userId: number,
  userProperties?: Record<string, any>
) => {
  try {
    if (typeof window !== "undefined" && posthog) {
      posthog.identify(userId.toString(), userProperties);
    }
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to identify user:", error);
    }
  }
};

export const captureEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  try {
    if (typeof window !== "undefined" && posthog) {
      // If user is not identified, this will use the anonymous ID
      posthog.capture(eventName, {
        ...properties,
        distinct_id: posthog.get_distinct_id(),
      });
    }
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to capture event:", error);
    }
  }
};

export const capturePageView = (url: string) => {
  try {
    captureEvent("$pageview", {
      url,
      distinct_id: posthog.get_distinct_id(),
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Failed to capture page view:", error);
    }
  }
};
